import { FaBars } from 'react-icons/fa';
import { NavLink as Link } from 'react-router-dom';
import styled from 'styled-components';


export const Nav = styled.nav`
background: #000;
height: 50px;
width: 100%;
display: fixed;
justify-content: space-between;
opacity: 0.9;
margin-top: 0px;
z-index: 1;
font-family:'Avenir';
font-size: 15px;
font-weight: bold;
position: sticky; 
top:0;

@media screen and (max-width: 768px){
  transition: 0.8 all ease;
}
`;


  
export const NavLink = styled(Link)`
  color: #fff;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;
  
  &:hover {
    transition: all 0.2s ease-in-out;
    color: grey;
  }

`;
  
export const Bars = styled(FaBars)`
  display: fixed;
  color: none;
  background-color: black;
  
  @media screen and (max-width: 768px) {
    display: fixed;
    position: absolute;
    top: 0;
    right: 0px;
    transform: translate(-100%, 25%);
    font-size: 1.8rem;
    cursor: pointer;
    width: 100%;
  }
`;
  
export const NavMenu = styled.div`
  display: fixed;
  align-items: center;

  
  /* Second Nav */
  margin-right: -24px;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

  
export const NavBtn = styled.nav`
  display: flex;
  align-items: center;
  margin-right: 24px;

 
  list-style: none;
  /* Third Nav */
  @media screen and (max-width: 500px) {
    
  }
  &:hover {
    transition: all 0.2s ease-in-out;
  }
`;
  
export const NavBtnLink = styled(Link)`
  border-radius: 4px;
  background: #ffffff;
  font-weight: bold;
  font-family:'Roboto';
  color: #5f1d57;
  padding: 10px 22px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  /* Second Nav */
  margin-left: 24px;
  margin-top: 0px;
  
  &:hover {
    transition: all 0.2s ease-in-out;
    background: #5f1d57;
    color: #ffffff;
    border: 1px solid #ffffff;
  }
`;


